export function useCache() {
    const setCache = (key, value) => {
        localStorage.setItem(key, JSON.stringify(value))
    }

    const getCache = (key) => {
        let value = localStorage.getItem(key)
        return value ? JSON.parse(value) : {}
    }

    const removeCache = (key) => {
        localStorage.removeItem(key)
    }

    return {
        getCache,
        setCache,
        removeCache
    }
}